import { BugOutlined, PhoneOutlined } from '@ant-design/icons';
import { faTelegram, faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Flex, Modal, Space, Typography } from 'antd';
import moment from 'moment';
import { Link } from 'react-router-dom';

import { MaxMessengerLogo } from '@app/assets';
import { APP_VERSION, APP_VERSION_TIMESTAMP } from '@app/data/version';
import { APP_VERSION_TIMEZONE_OFFSET } from '@app/shared/utils';
import { clearSessionStorageAndReload } from '@app/utils';

import type { FC } from 'react';

const { Text } = Typography;

interface HelpBoxModalProps {
  isOpened: boolean;
  onOk: () => void;
  onCancel: () => void;
}

export const HelpBoxModal: FC<HelpBoxModalProps> = ({
  isOpened,
  onOk,
  onCancel,
}) => {
  const systemVersionTimestamp = APP_VERSION_TIMESTAMP
    ? moment
        .unix(APP_VERSION_TIMESTAMP)
        .utcOffset(APP_VERSION_TIMEZONE_OFFSET)
        .format('HH:mm DD.MM.YYYY')
    : '';

  return (
    <Modal
      className="system-sidebar-help-box"
      title={null}
      open={isOpened}
      footer={false}
      width={360}
      onOk={onOk}
      onCancel={onCancel}
    >
      <div className="help-box">
        <Space direction="vertical" size="small">
          <Text strong className="pseudo-title">
            Техническая поддержка
          </Text>
          <Link to="https://wa.me/79802100010" target="_blank">
            <Button
              type="link"
              size="small"
              icon={
                <FontAwesomeIcon
                  icon={faWhatsapp}
                  style={{ color: 'green', fontSize: '16px' }}
                />
              }
            >
              +7 (980) 210-00-10
            </Button>
          </Link>
          <Link to="https://t.me/Byhelp_poddergka" target="_blank">
            <Button
              type="link"
              size="small"
              icon={
                <FontAwesomeIcon
                  icon={faTelegram}
                  style={{
                    fontSize: '16px',
                  }}
                />
              }
            >
              +7 (996) 268-73-30
            </Button>
          </Link>
          <Link
            to="https://max.ru/u/f9LHodD0cOImzkxuDOyWacqev4-GiYPI_Ckt2mfFDqfb3k8NNak6lYE_Udw"
            target="_blank"
          >
            <Button
              type="link"
              size="small"
              icon={
                <img
                  src={MaxMessengerLogo}
                  alt="MAX"
                  style={{
                    width: '16px',
                    height: '16px',
                  }}
                />
              }
            >
              +7 (996) 268-73-30
            </Button>
          </Link>
        </Space>

        <Space direction="vertical" size="small">
          <Text strong className="pseudo-title">
            Ваш личный менеджер
          </Text>
          <Link to="tel:+79030780044">
            <Button
              type="link"
              size="small"
              icon={<PhoneOutlined style={{ fontSize: '16px' }} />}
            >
              +7 (903) 078-00-44
            </Button>
          </Link>
          <Link to="tel:+79091464617">
            <Button
              type="link"
              size="small"
              icon={
                <img
                  src={MaxMessengerLogo}
                  alt="MAX"
                  style={{
                    width: '16px',
                    height: '16px',
                  }}
                />
              }
            >
              +7 (909) 146-46-17
            </Button>
          </Link>
          <Link to="https://t.me/ByHelper_CRM" target="_blank">
            <Button
              type="link"
              size="small"
              icon={
                <FontAwesomeIcon
                  icon={faTelegram}
                  style={{
                    fontSize: '16px',
                  }}
                />
              }
            >
              @ByHelper_CRM
            </Button>
          </Link>
        </Space>

        <Space direction="vertical" size="small">
          <Text strong className="pseudo-title knowledge-base">
            База знаний
          </Text>

          <Link to={'https://rutube.ru/channel/24052280/'} target="_blank">
            <Button type="link" size="small">
              Обучающие видео
            </Button>
          </Link>
          <Link
            to={
              'https://docs.google.com/document/d/' +
              '12pi89Mmw8x_diQYwYRRVOVWRpBroaTZcLA2AQATkkSs/edit?usp=sharing'
            }
            target="_blank"
          >
            <Button type="link" size="small">
              Обучающая документация
            </Button>
          </Link>
        </Space>

        <Space direction="vertical" size="small">
          <Button
            className="error-button"
            type="primary"
            icon={<BugOutlined />}
            onClick={onOk}
          >
            Сообщить об ошибке
          </Button>

          <Button
            className="cache-button"
            onClick={() => clearSessionStorageAndReload()}
          >
            Очистить кэш браузера
          </Button>

          <Flex vertical>
            <Text type="secondary" style={{ fontSize: 12 }}>
              Ваша версия системы: {APP_VERSION}
            </Text>
            {systemVersionTimestamp ? (
              <Text type="secondary" style={{ fontSize: 12 }}>
                Дата версии: {systemVersionTimestamp} (МСК)
              </Text>
            ) : null}
          </Flex>
        </Space>
      </div>
    </Modal>
  );
};
